import { useState, useEffect } from "react";

import axios from "axios";

const GetServicioByIdEvidenciaRequisito = ({ token, idEvidencia }) => {
  const [requisitosValidar, setRequisitosValidar] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_basicURL_gescae_evidencia}${idEvidencia}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(result);
      setRequisitosValidar(result.data);
    } catch (error) {
      console.log(error.message);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEvidencia, token]);

  return { requisitosValidar, error, loading };
};
export default GetServicioByIdEvidenciaRequisito;
